import { DeliveryServer } from '../delivery-server/delivery-server'
import { TrackingDomain } from '../tracking-domain/tracking-domain'
import { List } from '../list/list'

export class Campaign {
    subject: string = null
    body: string = null
    list: List = null
    deliveryServer: DeliveryServer = null
    trackingDomain: TrackingDomain = null
    fromName: string = null
    fromEmail: string = null
    replyTo: string = null
    service: string = null
    providers: number[] = []
}